export default __webpack_public_path__ + "static/bg-header-9c9204741fdcda6577972e52ff59650f.png";